/**
 * Converts a string to a URL-friendly slug
 * Preserves Arabic characters for Arabic text
 * @param {string} text - The text to convert to slug
 * @returns {string} - The slugified text
 */
export function createSlug(text) {
  if (!text) return "";
  
  const hasArabic = /[\u0600-\u06FF]/.test(text);
  
  if (hasArabic) {
    // For Arabic text: preserve Arabic characters, only clean spaces and special chars
    return text
      .toString()
      .trim()
      // Replace spaces and underscores with hyphens
      .replace(/\s+/g, '-')
      .replace(/_/g, '-')
      // Remove special characters but keep Arabic, Latin, numbers, and hyphens
      // Arabic Unicode range: \u0600-\u06FF
      // Latin word characters: \w (a-z, A-Z, 0-9, _)
      .replace(/[^\u0600-\u06FF\w\-]+/g, '')
      // Replace multiple hyphens with single hyphen
      .replace(/\-\-+/g, '-')
      // Remove leading and trailing hyphens
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  } else {
    // For non-Arabic text: use lowercase and standard slug format
    return text
      .toString()
      .toLowerCase()
      .trim()
      // Replace spaces and underscores with hyphens
      .replace(/\s+/g, '-')
      .replace(/_/g, '-')
      // Remove all non-word characters except hyphens
      .replace(/[^\w\-]+/g, '')
      // Replace multiple hyphens with single hyphen
      .replace(/\-\-+/g, '-')
      // Remove leading and trailing hyphens
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }
}
